// Sales Op. Python (Auto Jobs menu and the SOP Team job runner) — the screens' strings in the portal's four
// languages (2026-10-21). The job's own output is printed as the server streams it and is not translated.
const en = {
  sopTeam: 'SOP Team',
  title: 'Run Python Job',
  withoutNewOrder: 'Without New Order Job',
  newOrder: 'New Order Job',
  runJob: 'Run Job',
  running: 'Running...',
  starting: 'Starting...',
  noOutput: 'No output yet',
  connectError: 'Error connecting to server: {{message}}',
  notAuthorized: 'You are not authorized to run this job.',
};
const ko = {
  sopTeam: 'SOP 팀',
  title: 'Python 작업 실행',
  withoutNewOrder: '신규 오더 제외 작업',
  newOrder: '신규 오더 작업',
  runJob: '작업 실행',
  running: '실행 중...',
  starting: '시작하는 중...',
  noOutput: '아직 출력이 없습니다',
  connectError: '서버 연결 오류: {{message}}',
  notAuthorized: '이 작업을 실행할 권한이 없습니다.',
};
const vi = {
  sopTeam: 'Nhóm SOP',
  title: 'Chạy job Python',
  withoutNewOrder: 'Job không có đơn hàng mới',
  newOrder: 'Job đơn hàng mới',
  runJob: 'Chạy job',
  running: 'Đang chạy...',
  starting: 'Đang khởi động...',
  noOutput: 'Chưa có kết quả',
  connectError: 'Lỗi kết nối máy chủ: {{message}}',
  notAuthorized: 'Bạn không có quyền chạy job này.',
};
const zh = {
  sopTeam: 'SOP 团队',
  title: '运行 Python 任务',
  withoutNewOrder: '不含新订单任务',
  newOrder: '新订单任务',
  runJob: '运行任务',
  running: '运行中...',
  starting: '正在启动...',
  noOutput: '暂无输出',
  connectError: '连接服务器出错：{{message}}',
  notAuthorized: '您无权运行此任务。',
};

const dictionary = { ns: 'xJobs', en, ko, vi, zh };

export default dictionary;
